"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestAndRetry = exports.setLog = exports.log = void 0;
const badGateway = 502;
const serviceUnavailable = 503;
const gatewayTimeout = 504;
const retryErrors = [badGateway, serviceUnavailable, gatewayTimeout];
let log = (message) => console.log(message);
exports.log = log;
function setLog(newLog) {
    exports.log = newLog;
}
exports.setLog = setLog;
const requestAndRetry = async (tryRequest, retries = 0, route) => {
    let result;
    let error;
    while (!result && retries >= 0) {
        ({ result, error } = await tryRequest());
        if (error) {
            if (error.response) {
                (0, exports.log)(responseError(error.message, error.response.status, route, retries));
                if (!retryOnError(error.response.status)) {
                    break;
                }
            }
            else if (error) {
                (0, exports.log)(timeoutError(route, retries));
            }
        }
        retries--;
    }
    if (error) {
        throw error;
    }
    return result;
};
exports.requestAndRetry = requestAndRetry;
function retryOnError(status) {
    return retryErrors.indexOf(status) !== -1;
}
function responseError(message, status, route, retries) {
    return `An error occurred when fetching from ${route}: ${status} (${retries} retries left.) Error Message: ${message}`;
}
function timeoutError(route, retries) {
    return `A timeout error occurred when fetching from ${route}. (${retries} retries left.)`;
}
//# sourceMappingURL=timeout.js.map